const categoryType = {
  
    CREATE_CATEGORY: "CREATE_CATEGORY",
    CREATE_CATEGORY_COMMIT: "CREATE_CATEGORY_COMMIT",
    CREATE_CATEGORY_ROLLBACK: "CREATE_CATEGORY_ROLLBACK",
  
    RESET_CATEGORY: "RESET_CATEGORY",
  };
  
  export default categoryType;